// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopUp_Wrapper__U_lWR","Container":"PopUp_Container__Dn7Gj"};